import axios, { AxiosResponse, AxiosHeaders } from "axios";
import Cookies from "js-cookie";

const apiClient = axios.create({
  baseURL: (window as any).env.REACT_APP_BE_URL,
});

interface RequestParams {
  baseURL?: string | null;
  url: string;
  data?: Record<string, any>;
  headers?: Record<string, string>;
  accessToken?: boolean;
}

interface PostRequestParams extends RequestParams {
  options?: Record<string, any>;
}

const mergeHeaders = (headers: Record<string, string>, accessToken: boolean): AxiosHeaders => {
  const mergedHeaders = new AxiosHeaders({
    ...headers,
    ...(accessToken
      ? { Authorization: `Bearer ${Cookies.get("access_token") ?? ""}` }
      : {}),
  });
  return mergedHeaders;
};

export const get = async <T = any>({
  baseURL = null,
  url,
  data = {},
  headers = {},
  accessToken = true,
}: RequestParams): Promise<AxiosResponse<T>> => {
  const response = await apiClient.get<T>(url, {
    ...(baseURL && { baseURL }),
    params: data,
    headers: mergeHeaders(headers, accessToken),
  });
  return response;
};

export const post = async <T = any>({
  baseURL = null,
  url,
  data,
  headers = {},
  options = {},
  accessToken = true,
}: PostRequestParams): Promise<AxiosResponse<T>> => {
  const response = await apiClient.post<T>(url, data, {
    ...(baseURL && { baseURL }),
    headers: mergeHeaders(headers, accessToken),
    ...options,
  });
  return response;
};

export const postMultipart = async <T = any>(
  url: string,
  formData: FormData,
  headers: Record<string, string> = {}
): Promise<AxiosResponse<T>> => {
  const response = await apiClient.post<T>(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...headers,
    },
  });
  return response;
};

export const deleteRequest = async <T = any>({
  baseURL = null,
  url,
  data,
  headers = {},
  options = {},
  accessToken = true,
}: PostRequestParams): Promise<AxiosResponse<T>> => {
  const response = await apiClient.delete<T>(url, {
    ...(baseURL && { baseURL }),
    data,
    headers: mergeHeaders(headers, accessToken),
    ...options,
  });
  return response;
};
